const Data = {
  'Básico':
    [
      {
        id: "Básico_Carpintería",
        name: "Carpintería",
        category: "finishesWoodwork",
        options: [
          {
            id: "Básico_Carpintería_Madera",
            name: "Madera",
            price: '0',
            included: true,
            quote_text: 'Carpintería - Madera',
            image: require("../assets/images.jpg"),
            featureId: "",
          },
          {
            id: "Básico_Carpintería_Grafito",
            name: "Grafito",
            price: '5,000,000',
            included: false,
            quote_text: 'Carpintería - Grafito',
            image: require("../assets/Carpinteria_darkSteel.jpg"),
            featureId: "b6742c7f-f7a0-45a4-b322-a9ce8878763c",
          },
        ]
      },
      {
        id: "Básico_Piso",
        name: "Piso",
        category: "finishesFloor",
        options: [
          {
            id: "Básico_Piso_Madera",
            name: "Madera",
            price: '4,200,000',
            included: true,
            quote_text: 'Piso - Madera',
            image: require("../assets/Piso_Madera.jpg"),
            featureId: "aee8e0f0-5b9e-4496-9c92-4c5a2b370953",
          },
          {
            id: "Básico_Piso_Concreto",
            name: "Concreto",
            included: false,
            price: '6,000,000',
            quote_text: 'Piso - Concreto',
            image: require("../assets/Piso_Concreto.jpg"),
            featureId: "17efc8a6-10ca-4225-acaf-7dbaad40c377",
          },
        ]
      },
      {
        id: "Básico_Mesón",
        name: "Mesón",
        category: "finishesMeson",
        options: [
          {
            id: "Básico_Mesón_Blanco",
            name: "Blanco",
            price: '3,500,000',
            included: true,
            quote_text: 'Mesón - Blanco',
            image: require("../assets/Meson_Quarztone_gris.jpg"),
            featureId: "cf6ea954-fa89-40f8-a1c0-1a9ee2a37b72",
          },
          {
            id: "Básico_Mesón_Grafito",
            name: "Grafito",
            price: '3,600,000',
            included: false,
            quote_text: 'Mesón - Grafito',
            image: require("../assets/Carpinteria_darkSteel.jpg"),
            featureId: "a85be701-cf54-4998-b8bc-00f3e24996db",
          },
        ]
      },
    ],
  'Liviano':
    [
      {
        id: "Liviano_Baranda",
        name: "Baranda",
        category: "finishesRail",
        options: [
          {
            id: "Liviano_Baranda_Malla",
            name: "Malla",
            price: '1,400,000',
            included: false,
            quote_text: 'Baranda - Malla',
            image: require("../assets/Baranda_Malla.jpg"),
            featureId: "4f716fe9-ee27-4037-9dce-3cde1b241e23",
          },
          {
            id: "Liviano_Baranda_Policarbonato",
            name: "Policarbonato",
            price: '2,100,000',
            included: false,
            quote_text: 'Baranda - Policarbonato',
            image: require("../assets/Baranda_Policarbonato.jpg"),
            featureId: "a69816ca-c9f6-4fa5-a73d-f388473ea992",
          },
        ]
      },
      {
        id: "Liviano_Carpintería",
        name: "Carpintería",
        category: "finishesWoodwork",
        options: [
          {
            id: "Liviano_Carpintería_Madera",
            name: "Madera",
            price: '0',
            included: true,
            quote_text: 'Carpintería - Madera',
            image: require("../assets/images.jpg"),
            featureId: "",
          },
          {
            id: "Liviano_Carpintería_Grafito",
            name: "Grafito",
            price: '5,000,000',
            included: false,
            quote_text: 'Carpintería - Grafito',
            image: require("../assets/Carpinteria_darkSteel.jpg"),
            featureId: "b6742c7f-f7a0-45a4-b322-a9ce8878763c",
          },
        ]
      },
      {
        id: "Liviano_Piso",
        name: "Piso",
        category: "finishesFloor",
        options: [
          {
            id: "Liviano_Piso_Madera",
            name: "Madera",
            price: '4,200,000',
            included: true,
            quote_text: 'Piso - Madera',
            image: require("../assets/Piso_Madera.jpg"),
            featureId: "aee8e0f0-5b9e-4496-9c92-4c5a2b370953",
          },
          {
            id: "Liviano_Piso_Concreto",
            name: "Concreto",
            price: '6,000,000',
            included: false,
            quote_text: 'Piso - Concreto',
            image: require("../assets/Piso_Concreto.jpg"),
            featureId: "17efc8a6-10ca-4225-acaf-7dbaad40c377",
          },
        ]
      },
      {
        id: "Liviano_Mesón",
        name: "Mesón",
        category: "finishesMeson",
        options: [
          {
            id: "Liviano_Mesón_Blanco",
            name: "Blanco",
            price: '3,500,000',
            included: true,
            quote_text: 'Mesón - Blanco',
            image: require("../assets/Meson_Quarztone_gris.jpg"),
            featureId: "cf6ea954-fa89-40f8-a1c0-1a9ee2a37b72",
          },
          {
            id: "Liviano_Mesón_Grafito",
            name: "Grafito",
            price: '3,600,000',
            included: true,
            quote_text: 'Mesón - Grafito',
            image: require("../assets/Carpinteria_darkSteel.jpg"),
            featureId: "a85be701-cf54-4998-b8bc-00f3e24996db",
          },
        ]
      },
    ]
  }


module.exports = { Data };